vela.QuickView = (function() {
    var selectors = {
      body: 'body',
      quickView: '[data-quickview]',
      quickViewTemplate: '#quickview-template',
      quickViewBtn: '.js-btn-quickview',
      quickViewContainer: '[data-quickview-container]',
      quickViewClose: '[data-quickview-close]',
      quickViewImages: '[data-quickview-images]',
      quickViewReview: '[data-quickview-review]',
      quickviewVariant: '.js-quickview-option-selector',
      originalSelectorId: '[data-quickview-variant]',
      quickViewProductPrice: '.js-qv-product-price',
      quickViewProductPriceCompare: '.js-qv-product-price-compare',
      quickViewSKU: '[data-quickview-sku]',
      quickViewAvaiable: '.product-avaiable',
      quickViewAvaiableInStock: '.product-avaiable--instock',
      quickViewAvaiableInStockText: '.product-avaiable__text--instock',
      quickViewAvaiableOutStock: '.product-avaiable--outstock',
      quickViewProductDetailsURL: '.js-qv-product-details'
    };
    var preOrder = false;
    function QuickView(container) {
      this.$container = $(container);
      this.cache = {};
      this.productVariants = [];
      this.currentVariant = {};
      this.cacheSelectors();
      this.initializeEvents();
    }
  
    QuickView.prototype = _.assignIn({}, QuickView.prototype, {
      cacheSelectors: function() {
        this.cache = {
          $body: $('body'),
          $quickViewContainer: this.$container.find(selectors.quickViewContainer)
        };
      },
  
      initializeEvents: function() {
        var $this = this;
        $(selectors.body).on('click', selectors.quickViewBtn, function(e) {
          e.preventDefault();
          var productHandle = $(this).data('handle');
          preOrder = $(this).data('preorder');
          colorLabel = $(this).data('color-label')?$(this).data('color-label'):'';
          var shortProductDesc = $(this).find('.proShortDesc').html();
          
          $.getJSON('/products/' + productHandle + '.js',function(product){
            if(window.SoboPreviewApplyProduct)window.SoboPreviewApplyProduct(product);
            try {
            var copy={"chemise-blouse-oford":{"title":"Blouse femme en coton Oxford","description":"À l’aise dans sa blouse, avec une tenue soignée : cette coupe évasée laisse de la place pour bouger et tombe librement sur les hanches. Le coton Oxford apporte un relief discret et une jolie tenue, sans enlever son esprit décontracté. En blanc ou en bleu clair, avec des boutons blancs translucides, elle s’associe à un pantalon ajusté ou à une jupe en velours. Elle est coupée et confectionnée à Illkirch, en Alsace, dans un tissu fabriqué au Portugal."},"chemise-blouse-oxford":{"title":"Chemise homme en coton Oxford","description":"Une chemise en coton à porter au bureau comme le week-end. Sa coupe décontractée laisse de l’aisance, tandis que le tissage Oxford apporte un léger relief et de la tenue. Un bon équilibre pour une chemise qui reste soignée sans être trop habillée. Blanche ou bleu clair, elle se glisse sous une veste ou se porte simplement avec un jean. Son tissu 100 % coton de 140 g/m² est fabriqué au Portugal, puis la chemise est coupée et confectionnée à Illkirch, en Alsace."},"jupe-droite-en-velours-cotele":{"title":"Jupe droite en velours côtelé","description":"Une jupe crayon avec le caractère du velours côtelé. Ses côtes bien visibles donnent du relief à la silhouette, tandis que le coton offre un toucher doux. La coupe droite et mi-longue est complétée par deux poches pratiques et un zip au dos. Son vert foncé s’accorde avec une blouse claire ou une maille pour les journées fraîches. Une façon de porter la jupe crayon avec une matière qui change, fabriquée et confectionnée en Alsace."},"pantalon-femme-bleu-des-vosges":{"title":"Jean femme coupe droite en coton et lyocell","description":"Un jean droit agréable à porter du matin au soir. Son mélange de coton et de lyocell associe la tenue du tissu à un toucher doux et souple. Les 2 % d’élasthanne apportent de l’aisance pour bouger sans complexe. La coupe droite se marie aussi bien avec une blouse évasée qu’un haut rentré à la taille. Ce modèle à braguette zippée est proposé en bleu nuit et en anthracite. Fabriqué en France, il reprend les détails du jean dans un tissu de 340 g/m²."},"pantalon-homme-bleu-nuit":{"title":"Jean homme coupe droite en coton et lyocell","description":"Le confort d’un pantalon, avec l’allure d’un jean. Ce modèle homme à coupe droite laisse de l’aisance dans la jambe et se porte aussi facilement avec un t-shirt qu’avec une chemise. Le lyocell apporte douceur et souplesse au tissu, tandis que les 2 % d’élasthanne accompagnent vos mouvements. Son tissu de 340 g/m² garde de la tenue : il reprend les finitions du jean sans être un denim classique. Une braguette zippée et deux coloris faciles à associer, bleu nuit et anthracite, complètent ce modèle fabriqué en France."},"polaire-mixte-epaisse":{"title":"Veste polaire grattée mixte","description":"Une polaire chaude pour les journées fraîches. Sa matière grattée offre un toucher doux et une épaisseur confortable, à porter sur un haut léger pour compléter la tenue. Mixte et noire, elle s’associe facilement aux vêtements que vous avez déjà. Ce modèle en polyester est fabriqué au Portugal, de la matière à la confection."},"polaire-mixte":{"title":"Polaire fine mixte à poches zippées","description":"De la chaleur sans l’épaisseur : cette polaire fine garde un tombé souple et une sensation de légèreté. Elle se porte sur un t-shirt à la mi-saison et se glisse facilement sous une veste en hiver pour ajouter une couche chaude tout en restant à l’aise. Son ouverture zippée permet d’ajuster le confort au fil de la journée, et ses poches zippées gardent vos petits objets à portée de main. Mixte, elle existe en gris béton, marine et noir. La matière est fabriquée au Portugal et la confection réalisée en Alsace."},"polaire-cine-premium":{"title":"Veste polaire chinée mixte","description":"Une polaire qui tient chaud et habille vraiment la tenue. Son aspect chiné, sa texture travaillée et ses finitions marine lui donnent une allure élégante, facile à porter avec une chemise et un pantalon soigné. Sa matière épaisse et son col protecteur gardent tout le confort que l’on attend d’une polaire. La coupe droite est mixte, avec un zip autobloquant et un détail tricolore. Proposée en gris ou en vert, cette polaire est fabriquée en France : la matière est réalisée dans la région lyonnaise, puis la confection en Alsace."},"robe-polo-loriginal":{"title":"Robe en maille piquée de coton recyclé","description":"Une robe confortable qui fait une tenue à elle seule. Sa maille piquée donne du relief au coton recyclé, et sa coupe légèrement ajustée suit la silhouette. Le col zippé permet de varier l’ouverture selon vos envies. Le bleu roi apporte de la couleur, avec des baskets pour une journée décontractée ou des bottines pour sortir. Confectionnée en Alsace, cette robe associe une maille principale en coton recyclé à des finitions côtelées en coton biologique."},"short-en-coton-bio":{"title":"Short en coton bio épais","description":"Le short que l’on enfile pour se mettre à l’aise en rentrant chez soi. Son coton bio épais et doux, sa coupe classique et son cordon intérieur réglable invitent à profiter d’une soirée tranquille ou d’un week-end à la maison. Avec un t-shirt ou un sweat, il se porte aussi quand les beaux jours sont passés. Une poche arrière et de larges surpiqûres aux ourlets complètent les finitions. Noir ou sable, il accompagne aussi vos sorties décontractées quand la température le permet. Sa matière et sa confection sont réalisées en Grèce."},"surchemise-en-velours-cotele":{"title":"Surchemise en velours côtelé","description":"Un velours épais, des côtes bien dessinées et un toucher doux : cette surchemise donne du caractère à la tenue. Sa coupe ample laisse la place à un haut en dessous et permet de la porter à la place d’une veste à la mi-saison. Ouverte sur un t-shirt ou fermée comme une chemise, elle garde une allure décontractée. Son vert eucalyptus s’associe à un jean comme à un pantalon clair. Le velours côtelé 100 % coton est tissé en Alsace, où la surchemise est aussi confectionnée."},"hoodie-zippe-en-coton-bio":{"title":"Sweat à capuche zippé en coton bio","description":"Un intérieur doux en molleton gratté et une coupe ample dans laquelle on se sent à l’aise : ce sweat à capuche en coton bio est idéal pour les moments décontractés. Son zip permet de le porter ouvert sur un t-shirt ou fermé quand la fraîcheur s’installe. Le bleu marine s’accorde facilement avec vos pantalons, avec des finitions côtelées pour une allure soignée. Fabriqué en France, c’est le sweat que l’on garde à portée de main pour sortir ou rester tranquillement chez soi."},"tshirt-mixte-robuste-en-coton-bio":{"title":"T-shirt oversize en coton bio épais","description":"De l’ampleur, un coton bio doux et une matière dense qui donne de la tenue : ce t-shirt oversize est pensé pour les tenues décontractées. Ses épaules tombantes et sa coupe mixte laissent de l’aisance, pour le porter seul ou sous une surchemise. Le coton peigné, le col côtelé de 2,5 cm et les ourlets larges font toute la différence dans les finitions. Disponible en noir, blanc et sable, il est fabriqué en Grèce, du tissu à la confection."},"veste-dinan":{"title":"Veste workwear homme en denim bleu","description":"La veste en jean qui complète une tenue sans la compliquer. Sa coupe droite se porte sur un t-shirt comme sur une chemise, et les 2 % d’élasthanne donnent de l’aisance au denim de coton. La poche poitrine et les boutons sans nickel soulignent son esprit workwear. Son bleu ciel vif donne du caractère à la tenue, avec un pantalon sombre comme avec des couleurs plus claires. Son denim est tissé en Alsace, où la veste est également confectionnée."},"jean-femme-v1-bleu-des-vosges":{"title":"Jean femme coupe ajustée en coton et lyocell","description":"Une taille semi-haute et une coupe ajustée qui suit la jambe sans la serrer. Ce jean femme reste souple et agréable à porter grâce au mélange de coton et de lyocell, complété par 2 % d’élasthanne pour l’aisance. Son coloris gris-bleu, le Bleu des Vosges, s’accorde avec une blouse claire, une maille ou une polaire. La braguette à boutons complète ce modèle confectionné en France, dans un tissu de 300 g/m² fabriqué en Alsace."},"jean-homme-v1-bleu-des-vosges":{"title":"Jean homme coupe ajustée en coton et lyocell","description":"Une coupe ajustée qui suit la jambe sans la serrer. Ce jean homme garde de l’aisance et une sensation de légèreté grâce à son tissu souple en coton et lyocell. Les 2 % d’élasthanne accompagnent les mouvements pour un confort au quotidien. Sa nuance gris-bleu, le Bleu des Vosges, se porte aussi bien avec une chemise blanche qu’un sweat marine. La braguette à boutons apporte la finition classique du jean. Fabriqué en France, ce modèle utilise un tissu de 300 g/m²."},"veste-workwear-ecrue":{"title":"Veste workwear écrue en coton et lyocell","description":"Une veste écrue qui éclaire la tenue et reste agréable à porter. Le lyocell apporte douceur et souplesse au mélange de coton ; les 2 % d’élasthanne donnent de l’aisance aux mouvements. Sa coupe droite permet de la porter facilement sur une chemise ou un t-shirt. La poche poitrine et les boutons sans nickel gardent l’esprit workwear. Avec un pantalon bleu ou anthracite, l’écru crée un contraste simple et lumineux. Le tissu et la confection sont réalisés en Alsace."},"jupe-alize":{"title":"Jupe courte en velours côtelé","description":"Courte, douce au toucher et facile à porter, cette jupe met le velours côtelé à l’honneur. Sa coupe trapèze s’évase légèrement pour laisser de l’aisance, avec deux poches pratiques et une fermeture zippée. Vieux rose, vert eucalyptus ou vert foncé : trois couleurs à associer à une blouse, un t-shirt ou une maille. Avec des baskets ou des bottines, elle trouve facilement sa place dans vos tenues. Son velours 100 % coton est tissé en Alsace, où la jupe est également confectionnée."}}[productHandle];
            shortProductDesc=_.escape((product.description||'').replace(/<[^>]*>/g,' ').trim());
            var excluded={'pantalon-homme-bleu-nuit':'Bleu des Vosges','pantalon-femme-bleu-des-vosges':'Bleu des Vosges','chemise-blouse-oxford':'Rayures','veste-dinan':'Sable'}[productHandle];
            if(excluded){product.variants=product.variants.filter(function(v){return v.options.indexOf(excluded)===-1;});product.options.forEach(function(o,i){o.values=o.values.filter(function(value){return product.variants.some(function(v){return v.options[i]===value;});});});}
            $this.productVariants=product.variants;
            product.available=product.variants.some(function(v){return v.available;});
            if (product.available) {
              $this.firstAvailableVariant(product.variants, $this);
            } else {
              $this.currentVariant = product.variants[0];
            }
            $this.buildQuickView(product,shortProductDesc);
            $this.createImageCarousel();
            $this.updateMedia($this.currentVariant);
            $this.renderReview();
            $this.show();
            } catch(error){window.location.assign('/products/'+productHandle);}
          }).fail(function(){window.location.assign('/products/'+productHandle);});
        });
  
        $(selectors.body).on('click', selectors.quickViewClose, function(e) {
          e.preventDefault();
          $this.hide();
        });
  
        $(selectors.quickViewContainer).on('change', selectors.quickviewVariant, function(e) {
          $this.onVariantChange();
        });
      },
  
      firstAvailableVariant: function(variants, global) {
        global.productVariants = variants;
        for (var i = 0; i < variants.length; i++) {
          var variant = variants[i];
          if (variant.available) {
            global.currentVariant = variant;
            break;
          }
        }
      },
  
      buildQuickView: function(product,shortProductDesc) {
        var moneyFormat = vela.strings.moneyFormat;
        var currentVariant = this.currentVariant;
        var source = $(selectors.quickViewTemplate).html();
        var template = Handlebars.compile(source);
        var images = '';
        var price = '';
        var tags = '';
        var shortDescription = shortProductDesc;
        var qvObject = {
          id: product.id
        };
        if (product.media.length > 0) {
          images += '<div class="quickview-images__list slick-carousel mx-0" data-quickview-images>'
          for (var i = 0; i < product.media.length; i++) {
            var media = product.media[i];
            if (media.media_type === 'image') {
              images += '<div class="slick-carousel__item px-0"><div class="quickview-images__item" data-media-id=' +
                media.id + '><img class="img-fluid" alt="' +
                product.title + '" src="' +
                media.src + '" /></div></div>';
            }
          }
          images += '</div>'
        }
        qvObject.variantID = currentVariant.id;
        qvObject.sku = currentVariant.sku !== null && currentVariant.sku !== '' ? currentVariant.sku : 'N/A';
        qvObject.images = images;
        qvObject.title = product.title;
        qvObject.url = product.url;
        price += '<div class="price-container d-flex align-items-center">';
        var productCompareClass = product.compare_at_price > product.price ? '' : 'd-none';
        price += '<div class="js-qv-product-price product-single__price">' + vela.Currency.formatMoney(product.price, moneyFormat) + '</div>';
        price += '<div class="js-qv-product-price-compare product-single__price--compare-at ' + productCompareClass + '">' + vela.Currency.formatMoney(product.compare_at_price, moneyFormat) + '</div>';
        price += '</div>';
        qvObject.price = price;
        qvObject.shortDescription = shortDescription;
        qvObject.vendor = '<a href="/collections/vendors?q=' + product.type + '" title="' + product.type + '">'+ product.vendor + '</a>';
        qvObject.type = '<a href="/collections/types?q=' + product.type + '" title="' + product.type + '">' + product.type + '</a>';
        if (product.tags.length > 0) {
          var tag_lenght = product.tags.length > 2 ? 2 : product.tags.length;
          for (var i = 0; i < tag_lenght; i++) {
            if(i != 0) {
              tags += ',&nbsp;';
            }
            tags += '<a href="/collections/all/' + product.tags[i] +'" title="' + product.tags[i] +'">' + product.tags[i] +'</a>';
          }
        }
        qvObject.tags = tags;
        qvObject.variants = this.buildVariant(product);
        $(selectors.quickViewContainer).html(template(qvObject));
        // AFTER BUILD HTML
        this.updateMasterSelect(currentVariant);
        this.updatePrice(currentVariant);
        this.updateVariantsButton();
        this.updateSKU(currentVariant);
        this.updateProductAvaiable(currentVariant);
        this.updateDetailsLink(currentVariant);
        this.updateToolTip();
        // TODO: Add to cart ajax call
        this.qvAddToCart();
        this.updateMasterSelect(currentVariant);
      },
      convertToSlug: function(str) {
        return str.toLowerCase().replace(/[^a-z0-9 -]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-');
      },
      resizeImage: function (m, j) {
        if (j == null) {
            return m;
        }
        if (j == "master") {
            return m.replace(/http(s)?:/, "");
        }
        var i = m.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);
        if (i != null) {
            var k = m.split(i[0]);
            var l = i[0];
            return (k[0] + "_" + j + l).replace(/http(s)?:/, "");
        } else {
            return null;
        }
      },
      buildVariant: function(product) {
        var result = '';
        var currentVariant = this.currentVariant;
        if (product.options[0].name !== 'Title') {
          var options = product.options;
          for (var i = 0; i < options.length; i ++) {
            var option = options[i];
            var optionIndex = i + 1;
            result += '<div class="variants-wrapper product-form__item" data-quickview-variant-option="' + optionIndex + '">';
            result += '<label class="variants__label">' + option.name + '</label>';
            result += '<div class="variants__options">';
            if (vela.settings.quickViewVariantType === 'select') {
              result += '<select class="js-quickview-option-selector product-form__input form-select" data-id="quickViewOptionSelector-' + optionIndex + '" data-index="option' + optionIndex + '">';
              for (var j = 0; j < option.values.length; j ++) {
                var value = option.values[j];
                result += '<option value="' + _.escape(value) + '" ';
                result += currentVariant.options[i] === value ? 'selected="selected"' : '';
                result += '>' + value + '</option>';
              }
              result += '</select>';
            } else if (vela.settings.quickViewVariantType === 'radio') {
              for (var j = 0; j < option.values.length; j ++) {
                var value = option.values[j];
                var isDisable = true;
                var colorAttribute = '';
                // CHECK Product option is available or disabled
                for (var k = 0; k < this.productVariants.length; k ++) {
                  var variantCondition = this.productVariants[k];
                  if (variantCondition.available) {
                    if (i == 0 && variantCondition.option1 === value) {
                      isDisable = false;
                      break;
                    } else if (i == 1 && variantCondition.option2 === value && variantCondition.option1 == currentVariant.option1) {
                      isDisable = false;
                      break;
                    } else if (i == 2 && variantCondition.option3 === value && variantCondition.option2 == currentVariant.option2 && variantCondition.option1 == currentVariant.option1) {
                      isDisable = false;
                      break;
                    }
                  }
                }
                // SOBO: solid fabric colours, never product thumbnails.
                if (/couleur|color/i.test(option.name)) {
                  var palette=(window.SoboColorPalette||{});
                  colorAttribute='data-color="'+_.escape(value)+'" title="'+_.escape(value)+'" style="--sobo-qv-color:'+ (palette[value.toLowerCase()]||'#aaa')+'"';
                }
                result += '<div class="single-option-selector">';
                result += '<input type="radio" data-single-option-button';
                result += currentVariant.options[i] === value ? ' checked ' : ' ';
                if (isDisable) {
                  result += 'aria-label="'+_.escape(value)+' — indisponible pour cette combinaison"';
                }
                result += 'value="' + _.escape(value) + '" data-index="option' + optionIndex + '" name="option' + option.position + '" ';
                result += 'class="js-quickview-option-selector';
                if (isDisable) {
                  result += ' disabled';
                }
                result += '" id="quickview-product-option-' + i + '-' + value.toLowerCase() + '">';
                result += '<label for="quickview-product-option-' + i + '-' + value.toLowerCase() + '" ' + colorAttribute;
                if (isDisable) {
                  result += ' class="disabled"';
                }
                result += '>' + value + '<span class="d-none"></span></label>';
                result += '</div>';
              }
            }
            result += '</div>';
            result += '</div>';
          }
        }
        return result;
      },
      
  
      createImageCarousel: function() {
        $(selectors.quickView).find(selectors.quickViewImages).slick({
          infinite: false,
          rows: 0
        });
      },
  
      renderReview: function() {
        if (window.SPR && vela.settings.enableReview) {
          if ($(selectors.quickView).find(selectors.quickViewReview).length) {
            return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
          };
        }
      },
  
      qvAddToCart: function(){
        if (vela.settings.cartType != "page"){
            ajaxCart.init({
                formSelector: '.formQuickview',
                cartContainer: '[data-cart-container]',
                addToCartSelector: 'button[type="submit"]',
                cartCountSelector: '[data-cart-count]',
                cartCostSelector: '[data-cart-cost]',
                moneyFormat: vela.strings.moneyFormat
            });
        }
      },
  
      getCurrentOptions: function() {
        var currentOptions = _.map(
          $(selectors.quickviewVariant, selectors.quickViewContainer), function(element) {
            var $element = $(element);
            var type = $element.attr('type');
            var currentOption = {};
            if (type === 'radio' || type === 'checkbox') {
              if ($element[0].checked) {
                currentOption.value = $element.val();
                currentOption.index = $element.data('index');
                return currentOption;
              } else {
                return false;
              }
            } else {
              currentOption.value = $element.val();
              currentOption.index = $element.data('index');
              return currentOption;
            }
          }
        );
        currentOptions = _.compact(currentOptions);
        return currentOptions;
      },
  
      getVariantFromOptions: function() {
        var selectedValues = this.getCurrentOptions();
        var variants = this.productVariants;
        var found = _.find(variants, function(variant) {
          return selectedValues.every(function(values) {
            return _.isEqual(variant[values.index], values.value);
          });
        });
  
        return found;
      },
  
      updateVariantsButton: function () {
        var selected=this.getCurrentOptions(),variants=this.productVariants;
        $(selectors.quickviewVariant,selectors.quickViewContainer).each(function(){
          var input=$(this),index=input.data('index'),value=input.val();
          var available=variants.some(function(v){return v.available&&v[index]===value&&selected.every(function(s){return s.index===index||v[s.index]===s.value;});});
          input.removeAttr('disabled').toggleClass('disabled',!available);
          input.next('label').toggleClass('disabled',!available);
          input.attr('aria-label',value+(available?'':' — indisponible pour cette combinaison'));
        });
      },

      updateVariantsButtonDisabed: function() {
        for (var i = 2; i <= 3; i++) {
          if ($('[data-quickview-variant-option="' + i + '"]', selectors.quickViewContainer).length) {
            var isUpdate = false;
            $('[data-quickview-variant-option="' + i + '"] ' + selectors.quickviewVariant, selectors.quickViewContainer).each(function() {
              var $element = $(this);
              var type = $element.attr('type');
              if (type === 'radio' || type === 'checkbox') {
                if (this.checked && $element.hasClass('disabled')) {
                  $element.prop('checked', false);
                  isUpdate = true;
                  return false;
                }
              }
            });
            $('[data-quickview-variant-option="' + i + '"] ' + selectors.quickviewVariant, selectors.quickViewContainer).each(function() {
              var $element = $(this);
              var type = $element.attr('type');
              if (isUpdate && (type === 'radio' || type === 'checkbox') && !$element.hasClass('disabled')) {
                $element.prop('checked', true);
                isUpdate = false;
                $element.trigger('change');
                return false;
              }
            });
          }
        }
      },
  
      updateMasterSelect: function(variant) {
        if (variant) {
          document.querySelectorAll('[data-quickview-container] input[name="id"]').forEach(function(input){input.value=String(variant.id);input.defaultValue=String(variant.id);input.setAttribute('data-sobo-variant',String(variant.id));});
        }
      },
  
      updateMedia: function(variant) {
        var media=variant&&(variant.featured_media||variant.featured_image);
        if (media && media.id) {
          $(selectors.quickViewImages, selectors.quickViewContainer).find('.quickview-images__item').each(function() {
            var imageID = $(this).data('media-id');
            if (media.id == imageID) {
              var slickIndex = $(this).closest('.slick-carousel__item').data('slick-index');
              if (slickIndex !== undefined && slickIndex !== null) {
                $(selectors.quickViewImages, selectors.quickViewContainer).slick('slickGoTo', slickIndex);
              }
            }
          });
        }
      },
  
      updatePrice: function(variant) {
        var moneyFormat = vela.strings.moneyFormat;
        if (!variant) {
          $(selectors.quickViewProductPrice, selectors.quickViewContainer).addClass('d-none');
          $(selectors.quickViewProductPriceCompare, selectors.quickViewContainer).addClass('d-none');
        } else {
          $(selectors.quickViewProductPrice, selectors.quickViewContainer).removeClass('d-none');
          $(selectors.quickViewProductPriceCompare, selectors.quickViewContainer).removeClass('d-none');
          $(selectors.quickViewProductPrice, selectors.quickViewContainer).html(
            vela.Currency.formatMoney(variant.price, moneyFormat)
          );
          if (variant.compare_at_price > variant.price) {
            $(selectors.quickViewProductPriceCompare, selectors.quickViewContainer).html(
              vela.Currency.formatMoney(variant.compare_at_price, moneyFormat)
            ).removeClass('d-none');
            $(selectors.quickViewProductPrice, selectors.quickViewContainer).addClass('on-sale');
          } else {
            $(selectors.quickViewProductPriceCompare, selectors.quickViewContainer).addClass('d-none');
            $(selectors.quickViewProductPrice, selectors.quickViewContainer).removeClass('on-sale');
          }
        }
      },
  
      updateSKU: function(variant) {
        var sku = variant && variant.sku !== null && variant.sku !== '' ? variant.sku : 'N/A';
        $(selectors.quickViewSKU, selectors.quickViewContainer).html(sku);
      },
  
      updateProductAvaiable: function(variant) {
        var classActive = 'product-avaiable--active';
        var translations = vela.strings;
        
        $(selectors.quickViewAvaiable, selectors.quickViewContainer).removeClass(classActive);
        if(preOrder) {
          $(selectors.quickViewAvaiableInStockText, selectors.quickViewContainer).addClass('text-info').html(translations.preOrder);
        }
        if (variant) {
          if (variant.available) {
            $(selectors.quickViewQty, selectors.quickViewContainer).removeClass('d-none');
            $(selectors.quickViewAvaiableInStock, selectors.quickViewContainer).addClass(classActive);
          } else {
            $(selectors.quickViewQty, selectors.quickViewContainer).addClass('d-none');
            $(selectors.quickViewAvaiableOutStock, selectors.quickViewContainer).addClass(classActive);
          }
  
          // Button add to cart
          if (variant.available) {
            $(selectors.quickViewContainer).find('.btn--add-to-cart').removeClass('disabled').prop('disabled', false);
            if ( preOrder ) {
              $(selectors.quickViewContainer).find('.btn--add-to-cart .btn__text').html(translations.preOrder);
            } else {
              $(selectors.quickViewContainer).find('.btn--add-to-cart .btn__text').html(translations.addToCart);
            }
          } else {
            $(selectors.quickViewContainer).find('.btn--add-to-cart')
              .addClass('disabled')
              .prop('disabled', true);
            $(selectors.quickViewContainer).find('.btn--add-to-cart .btn__text').html(translations.soldOut);
          }
        } else {
          $(selectors.quickViewQty, selectors.quickViewContainer).addClass('d-none');
          $(selectors.quickViewContainer).find('.btn--add-to-cart')
            .addClass('disabled')
            .prop('disabled', true);
          $(selectors.quickViewContainer).find('.btn--add-to-cart .btn__text').html(translations.unavailable);
        }
      },
  
      updateDetailsLink: function(variant) {
        if (variant) {
          var productURL = $(selectors.quickViewProductDetailsURL, selectors.quickViewContainer).data('url') + '?variant=' + variant.id;
          $(selectors.quickViewProductDetailsURL, selectors.quickViewContainer).removeClass('d-none').attr('href', productURL);
        } else {
          $(selectors.quickViewProductDetailsURL, selectors.quickViewContainer).addClass('d-none');
        }
      },
      
      updateToolTip: function() {
        $('[data-qv-toggle="tooltip"]', selectors.quickViewContainer).tooltip();
      },
  
      onVariantChange: function() {
        var variant = this.getVariantFromOptions();
        this.updateVariantsButton();
        this.updateMasterSelect(variant);
        this.updateMedia(variant);
        this.updatePrice(variant);
        this.updateSKU(variant);
        this.updateProductAvaiable(variant);
        this.updateDetailsLink(variant);
        this.currentVariant = variant;
      },
  
      show: function() {
        this.updateMasterSelect(this.currentVariant);
        $(selectors.body).addClass('quickview-active');
        $(selectors.quickView).addClass('show');
      },
  
      hide: function() {
        $(selectors.quickViewContainer).html();
        $(selectors.body).removeClass('quickview-active');
        $(selectors.quickView).removeClass('show');
      }
    });
  
    return QuickView;
  })();
(function(){if(!document.getElementById("sobo-quickview-da")){var style=document.createElement("style");style.id="sobo-quickview-da";style.textContent=".quickview__content{background:#f8f7f5!important;color:#17385f!important}.product-quickview,.product-quickview label,.product-quickview button{font-family:Arial,Helvetica,sans-serif!important;color:#17385f}.product-quickview__title{font:700 20px/1.3 Arial!important;text-transform:uppercase;color:#17385f!important}.product-quickview__description{font:14px/1.65 Arial!important;color:#17385f}.product-quickview .price-container{gap:10px}.product-quickview .product-single__price,.product-quickview .product-single__price--compare-at{font:700 20px/1.3 Arial!important;margin:0!important}.product-quickview .product-single__price--compare-at{order:-1;color:#aaa!important;text-decoration:line-through}.product-quickview .variants__label{font:12px/1.4 Arial!important;text-transform:uppercase}.product-quickview .variants__options{display:flex;flex-wrap:wrap;gap:8px}.product-quickview .single-option-selector{margin:0!important}.product-quickview .single-option-selector label{position:relative;min-width:34px;padding:7px 9px!important;border:1px solid #d8cfc2!important;border-radius:3px!important;background:#eee8df;color:#17385f!important;font:12px/1.3 Arial!important}.product-quickview .single-option-selector input:checked+label{background:#17385f!important;color:white!important;border-color:#17385f!important}.product-quickview .single-option-selector label.disabled{opacity:.5;text-decoration:line-through!important}.product-quickview .single-option-selector label[data-color]{display:block;width:26px!important;height:26px!important;min-width:26px;padding:3px!important;border-radius:0!important;font-size:0!important;background:var(--sobo-qv-color)!important;background-image:none!important;box-shadow:inset 0 0 0 3px #f8f7f5}.product-quickview .single-option-selector input:checked+label[data-color]{background:var(--sobo-qv-color)!important;outline:1px solid #17385f;outline-offset:2px}.product-quickview .single-option-selector label[data-color].disabled:after{content:'';position:absolute;left:0;top:50%;width:100%;height:1px;background:#17385f;transform:rotate(-45deg)}.product-quickview .btn--add-to-cart{background:#17385f!important;color:white!important;border:1px solid #17385f!important;text-transform:uppercase;font:700 12px Arial!important}.product-quickview .btn--add-to-cart:hover{background:#eee8df!important;color:#17385f!important;border-color:#d8cfc2!important}.product-quickview .btn--add-to-cart:disabled{opacity:.5;cursor:not-allowed}.product-quickview .vela-qty{border:1px solid #d8cfc2;background:#f8f7f5}.quickview__btn-close{color:#17385f!important}.product-quickview .slick-arrow{background:#eee8df!important;color:#17385f!important}.product-quickview input:focus-visible+label{outline:2px solid #17385f;outline-offset:3px}";document.head.appendChild(style);}})();

(function(){var style=document.createElement("style");style.textContent=".product-card .js-btn-quickview{color:#17385f!important;font-family:Arial,Helvetica,sans-serif!important}.product-card .btn--quickview{background:#f8f7f5!important;border-color:#d8cfc2!important}.product-card .btn--quickview:hover{background:#eee8df!important}.product-card .js-btn-quickview .tooltip-inner{background:#17385f!important;color:white!important}@media(min-width:992px) and (hover:hover){.product-card .js-btn-quickview.btn--add-to-cart{opacity:0;visibility:hidden;transition:opacity .15s}.product-card:hover .js-btn-quickview.btn--add-to-cart,.product-card:focus-within .js-btn-quickview.btn--add-to-cart{opacity:1;visibility:visible}}";document.head.appendChild(style);})();

(function(){var style=document.createElement("style");style.id="sobo-quickview-square-swatches";style.textContent=".product-quickview .single-option-selector label[data-color]::before,.product-quickview .single-option-selector label[data-color]::after{content:none!important;border-radius:0!important}.product-quickview .single-option-selector label[data-color].disabled::after{content:''!important;position:absolute!important;inset:auto!important;left:0!important;top:50%!important;width:100%!important;height:1px!important;padding:0!important;border:0!important;border-radius:0!important;background:#17385f!important;box-shadow:none!important;transform:rotate(-45deg)!important}";document.head.appendChild(style);})();

(function(){var style=document.createElement("style");style.id="sobo-quick-add-red-underline";style.textContent=".product-card .js-btn-quickview.btn--add-to-cart,.product-card .js-btn-quickview.btn--add-to-cart:hover,.product-card .js-btn-quickview.btn--add-to-cart:focus-visible{border-bottom-color:#ce1126!important;text-decoration-color:#ce1126!important}.product-card .js-btn-quickview.btn--add-to-cart:before,.product-card .js-btn-quickview.btn--add-to-cart:after{border-bottom-color:#ce1126!important}";document.head.appendChild(style);})();
